import React from "react";
import { Button } from "@chakra-ui/react";

type NoSearchResultsProps = {
  onSeeAll: () => void;
};

const NoSearchResults: React.FC<NoSearchResultsProps> = ({ onSeeAll }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full lg:py-[130px] py-[80px] text-center">
      <img
        src="/assets/vaults/no_result.avif"
        alt="No results found"
        className="h-auto w-[159px]"
      />
      <div className="mt-6">
        <p className="text-2xl font-semibold text-text-primary">
          No results found.
        </p>
        <p className="mt-2 text-sm text-text-secondary max-w-xl">
          Try searching with a different term or explore all vaults
        </p>
      </div>
      <Button
        h="44px"
        minW="92px"
        borderRadius="8px"
        backgroundColor="#075A5A"
        color="white"
        onClick={onSeeAll}
        mt="20px"
        fontSize="14px"
        fontWeight="400"
      >
        See all vaults
      </Button>
    </div>
  );
};

export default NoSearchResults;
